


import React, { useState, useEffect, useMemo, useRef } from 'react';
import Backdrop from '../Backgrounds/Backdrop';
import LogoLoader from '../Loading/LogoLoader';
import { showToast } from '../Toast/Toast';
import { isFileTypeMissingFromUrl } from '../../utils/common';

// const DocumentViewerATS = ({ AwsResumeUrl, urlLoading = false }) => {
//   const AwsUrl = AwsResumeUrl ?? "";
//   const [txtContent, setTxtContent] = useState('');
//   const fileExtension = AwsUrl.includes(".")
//     ? AwsUrl?.split(".")
//       .pop()
//       .split("?")[0]
//       .toLowerCase() : "";

//   useEffect(() => {
//     if (fileExtension === 'txt' || fileExtension === 'rtf') {
//       const fetchFileContent = async () => {
//         try {
//           const response = await fetch(AwsUrl);
//           if (!response.ok) {
//             throw new Error('Network response was not ok');
//           }
//           const text = await response.text();
//           setTxtContent(text);
//         } catch (error) {
//           setTxtContent(`Error loading ${fileExtension.toUpperCase()} file content.`);
//         }
//       };
//       fetchFileContent();
//     }
//   }, [AwsUrl, fileExtension]);

//   if (urlLoading) {
//     return (
//       <div style={{ textAlign: 'center' }}>
//         <Backdrop isOpen={urlLoading} zIndex={52}>
//           <LogoLoader />
//         </Backdrop>
//       </div>
//     );
//   }

//   if (!AwsUrl) {
//     return (
//       <div style={{ textAlign: "center" }}>
//         No resume available.
//       </div>
//     );
//   }

//   if (fileExtension === 'pdf' || fileExtension === 'docx' || fileExtension === 'doc') {
//     return (
//       <iframe
//         src={`https://docs.google.com/gview?url=${encodeURIComponent(AwsUrl)}&embedded=true`}
//         style={{ width: '100%', height: '80vh', border: 'none' }}
//         title="Resume"
//       />

//     );
//   } else if (fileExtension === 'txt') {
//     return (
//       <div style={{ whiteSpace: 'pre-wrap', padding: '20px', border: '1px solid #ccc' }}>
//         <h6>Resume {fileExtension.toUpperCase()} Content:</h6>
//         <pre>{txtContent}</pre>
//       </div>
//     );
//   } else if (fileExtension === 'rtf') {
//     const microsoftViewerUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(AwsUrl)}`;

//     return (
//       <>
//         <iframe
//           src={microsoftViewerUrl}
//           style={{ width: '100%', height: '80vh', border: 'none' }}
//           title="Resume RTF"
//         />
//         <div variant="h6" textAlign="center">
//           Unable to display RTF file. Please{" "}
//           <a href={AwsUrl} target="_blank" rel="noopener noreferrer">
//             download the file
//           </a>
//           .
//         </div>
//       </>
//     );
//   }

//   else if (fileExtension === 'html' || fileExtension === 'htm') {
//     return (
//       <iframe
//         src={AwsUrl}
//         title="Resume HTML"
//         style={{ width: '100%', height: '900px', border: 'none' }}
//       />
//     );
//   } else {
//     // Fallback for unsupported formats
//     return (
//       <div variant="h6" textAlign="center">
//         The file format is not supported for inline viewing. Please{" "}
//         <a href={AwsUrl} target="_blank" rel="noopener noreferrer">
//           download the resume
//         </a>
//         .
//       </div>
//     );
//   }

// };

// const DocumentViewerATS =  ({ AwsResumeUrl, urlLoading = false,htmlFormat }) => {
//   const AwsUrl = AwsResumeUrl?.trim() || "";
//   const fileFormateWorng = isFileTypeMissingFromUrl(AwsUrl);


//   const [txtContent, setTxtContent] = useState("");
//   const [iframeFailed, setIframeFailed] = useState(false);
//   const [iframeLoading, setIframeLoading] = useState(false);

//   const currentUrlRef = useRef(AwsUrl);

//   const fileExtension = useMemo(() => {
//     if (!AwsUrl || !AwsUrl.includes(".")) return "";
//     return AwsUrl.split(".").pop().split("?")[0].toLowerCase();
//   }, [AwsUrl]);

//   useEffect(() => {
//     currentUrlRef.current = AwsUrl;
//     setIframeFailed(false);
//     setIframeLoading(true);
//     setTxtContent("");
//   }, [AwsUrl]);

//   useEffect(() => {
//     if (fileExtension !== "txt" || !AwsUrl) return;
//     const controller = new AbortController();
//     const fetchFileContent = async () => {
//       try {
//         const response = await fetch(AwsUrl, {
//           mode: "cors",
//           signal: controller.signal,
//         });
//         if (!response.ok) throw new Error("Fetch failed");
//         const text = await response.text();
//         setTxtContent(text);
//       } catch (error) {
//         if (error.name === "AbortError") return; // ignore aborted fetch
//         console.error("TXT fetch error:", error);
//         setTxtContent("Unable to load TXT file content.");
//       }
//     };
//     fetchFileContent();
//     return () => {
//       controller.abort(); // cancel previous fetch on fast switch
//     };
//   }, [AwsUrl, fileExtension]);
//   useEffect(() => {
//     if (fileFormateWorng) {
//       showToast(
//         "File format of this resume is not valid hence this resume can not be opened",
//         "warning"
//       );
//     }
//   }, [fileFormateWorng]);

//   if (htmlFormat && fileFormateWorng) {
//     return (
//       <div
//         style={{
//           whiteSpace: "pre-wrap",
//           padding: "20px",
//           border: "1px solid #ccc",
//           maxHeight: "80vh",
//           overflow: "auto",
//         }}
//       >
//         <div dangerouslySetInnerHTML={{ __html: htmlFormat }} />
//       </div>
//     );
//   }
//   if (urlLoading) {
//     return (
//       <div style={{ textAlign: "center" }}>
//         <Backdrop isOpen={urlLoading} zIndex={52}>
//           <LogoLoader />
//         </Backdrop>
//       </div>
//     );
//   }

//   if (!AwsUrl) {
//     return <div style={{ textAlign: "center" }}>No resume available.</div>;
//   }

//   const handleIframeError = (urlAtRenderTime) => {
//     if (currentUrlRef.current !== urlAtRenderTime) return;

//     setTimeout(() => {
//       if (
//         currentUrlRef.current === urlAtRenderTime &&
//         iframeLoading
//       ) {
//         setIframeFailed(true);
//         setIframeLoading(false);
//       }
//     }, 0);
//   };

//   const renderFallback = () => (
//     <div style={{ textAlign: "center", padding: "20px" }}>
//       <p>This file cannot be displayed inline due to security restrictions.</p>
//       <a href={AwsUrl} target="_blank" rel="noopener noreferrer">
//         Download the resume
//       </a>
//     </div>
//   );

//   if ([ "doc", "docx"].includes(fileExtension)) {
//     const viewerUrl = `https://docs.google.com/gview?url=${encodeURIComponent(
//       AwsUrl
//     )}&embedded=true`;

//     return iframeFailed ? (
//       renderFallback()
//     ) : (
//       <iframe
//         key={AwsUrl}
//         src={viewerUrl}
//         title="Resume Viewer"
//         style={{ width: "100%", height: "80vh", border: "none" }}
//         onError={() => handleIframeError(AwsUrl)}
//         onLoad={() => setIframeLoading(false)}
//       />
//     );
//   }
//  if (fileExtension === 'pdf') {
//     return (
//       <iframe
//         src={AwsUrl}
//         title="Resume PDF"
//    style={{ width: "100%", height: "80vh", border: "none" }}
//       />
//     );
//   }
//   if (fileExtension === "txt") {
//     return (
//       <div
//         style={{
//           whiteSpace: "pre-wrap",
//           padding: "20px",
//           border: "1px solid #ccc",
//           maxHeight: "80vh",
//           overflow: "auto",
//         }}
//       >
//         <h6>Resume TXT Content:</h6>
//         <pre>{txtContent}</pre>
//       </div>
//     );
//   }

//   if (fileExtension === "rtf") {
//     const microsoftViewerUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
//       AwsUrl
//     )}`;

//     return iframeFailed ? (
//       renderFallback()
//     ) : (
//       <iframe
//         key={AwsUrl}
//         src={microsoftViewerUrl}
//         title="Resume RTF"
//         style={{ width: "100%", height: "80vh", border: "none" }}
//         onError={() => handleIframeError(AwsUrl)}
//         onLoad={() => setIframeLoading(false)}
//       />
//     );
//   }

//   if (fileExtension === "html" || fileExtension === "htm") {
//     return iframeFailed ? (
//       renderFallback()
//     ) : (
//       <iframe
//         key={AwsUrl}
//         src={AwsUrl}
//         title="Resume HTML"
//         style={{ width: "100%", height: "80vh", border: "none" }}
//         sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
//         onError={() => handleIframeError(AwsUrl)}
//         onLoad={() => setIframeLoading(false)}
//       />
//     );
//   }

//   return renderFallback();
// };

// export default DocumentViewerATS;

const DOC_VIEW_TIMEOUT = 1000; // 1 seconds
const DocumentViewerATS = ({ AwsResumeUrl, urlLoading = false, htmlFormat }) => {
  const AwsUrl = AwsResumeUrl?.trim() || "";
  const fileFormateWorng = isFileTypeMissingFromUrl(AwsUrl);
  const [mode, setMode] = useState("IFRAME");
  const [txtContent, setTxtContent] = useState("");
  const [iframeFailed, setIframeFailed] = useState(false);
  const [iframeLoading, setIframeLoading] = useState(false);
  const [showSlowWarning, setShowSlowWarning] = useState(false);
  const [retryCount, setRetryCount] = useState(0);
  const currentUrlRef = useRef(AwsUrl);
  const iframeRef = useRef(null);
  const timeoutRef = useRef(null);
  const loadedRef = useRef(false);
  const fileExtension = useMemo(() => {
    if (!AwsUrl || !AwsUrl.includes(".")) return "";
    return AwsUrl.split(".").pop().split("?")[0].toLowerCase();
  }, [AwsUrl]);
   function formatResume(html) {
    const formattedHtml=html
      .replace(
        /(^|\n)((?:[A-Z][A-Z ]{2,}|[A-Z][A-Za-z &\-\/]+):?)(?=\n)/g,
        '$1\n<strong class="resume-heading">$2</strong>'
      )

      // Add spacing before major sections
      .replace(
        /\n(<strong class="resume-heading">)/g,
        '\n\n$1'
      );
        const finalHtml = `
        <style>
      .resume-pre {
        font-family: "Segoe UI", Arial, sans-serif;
        font-size: 14px;
        line-height: 1.65;
        color: #1f2937;
        background: #ffffff;
        padding: 24px;
        border-radius: 8px;
        white-space: pre-wrap;
      }

      .resume-heading {
        display: block;
        font-size: 16px;
        font-weight: 700;
        color: #0f172a;
        margin: 20px 0 8px;
        text-transform: uppercase;
        border-bottom: 2px solid #e5e7eb;
        padding-bottom: 4px;
      }

      /* Bullet points */
      .resume-pre ul,
      .resume-pre li {
        margin-left: 16px;
      }

      /* Improve readability on large screens */
      @media (min-width: 1024px) {
        .resume-pre {
          max-width: 900px;
          margin: auto;
        }
      }
    </style>

    <pre class="resume-pre">
${formattedHtml}
    </pre>
  `;
    return  finalHtml
  }
 useEffect(() => {
    if (!["doc", "docx"].includes(fileExtension)) return;
    loadedRef.current = false;
    setIframeLoading(true);
    timeoutRef.current = setTimeout(() => {
      if (!loadedRef.current) {
        setMode("HTML");
      }
    }, DOC_VIEW_TIMEOUT);
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, [fileExtension]);
  useEffect(() => {
    currentUrlRef.current = AwsUrl;
    setIframeFailed(false);
    setIframeLoading(true);
    setTxtContent("");
    setShowSlowWarning(false);
    setRetryCount(0);
  }, [AwsUrl]);

  useEffect(() => {
    if (fileExtension !== "txt" || !AwsUrl) return;
    const controller = new AbortController();
    const fetchFileContent = async () => {
      try {
        const response = await fetch(AwsUrl, {
          mode: "cors",
          signal: controller.signal,
        });
        if (!response.ok) throw new Error("Fetch failed");
        const text = await response.text();
        setTxtContent(text);
        setIframeLoading(false);
      } catch (error) {
        if (error.name === "AbortError") return;
        console.error("TXT fetch error:", error);
        setTxtContent("Unable to load TXT file content.");
        setIframeLoading(false);
      }
    };
    fetchFileContent();
    return () => {
      controller.abort();
    };
  }, [AwsUrl, fileExtension]);

  useEffect(() => {
    if (fileFormateWorng) {
      showToast(
        "File format of this resume is not valid hence this resume can not be opened",
        "warning"
      );
    }
  }, [fileFormateWorng]);

  // Show warning after 8 seconds (increased for Office viewer)
  useEffect(() => {
    if (!iframeLoading) {
      setShowSlowWarning(false);
      return;
    }

    const timer = setTimeout(() => {
      if (iframeLoading) {
        setShowSlowWarning(true);
      }
    }, 8000);

    return () => clearTimeout(timer);
  }, [iframeLoading]);

  if (htmlFormat && fileFormateWorng) {
    return (
      <div
            style={{
        height: "80vh",
        overflow: "auto",
        background: "#f8fafc",
       // padding: "16px",
      }}
      >
        <div dangerouslySetInnerHTML={{ __html: formatResume(htmlFormat) }} />
      </div>
    );
  }

  if (urlLoading) {
    return (
      <div style={{ textAlign: "center" }}>
        <Backdrop isOpen={urlLoading} zIndex={52}>
          <LogoLoader />
        </Backdrop>
      </div>
    );
  }

  if (!AwsUrl) {
    return <div style={{ textAlign: "center" }}>No resume available.</div>;
  }

  const handleIframeError = () => {
    
    // Auto-retry once for Office viewer
    if (retryCount < 1 && ["doc", "docx"].includes(fileExtension)) {
      setRetryCount(retryCount + 1);
      setIframeLoading(true);
      // Force iframe reload
      setTimeout(() => {
        if (iframeRef.current) {
          iframeRef.current.src = iframeRef.current.src;
        }
      }, 1000);
    } else {
      setIframeFailed(true);
      setIframeLoading(false);
    }
  };

  const handleIframeLoad = () => {
    setIframeLoading(false);
    setIframeFailed(false);
  };

  // const renderFallback = () => (
  //   <div style={{ textAlign: "center", padding: "20px" }}>
  //     <p style={{ marginBottom: "15px", color: "#666" }}>
  //       Unable to display this document inline.
  //     </p>
  //     <div style={{ display: "flex", gap: "10px", justifyContent: "center", flexWrap: "wrap" }}>
  //       <a
  //         href={AwsUrl}
  //         target="_blank"
  //         rel="noopener noreferrer"
  //         style={{
  //           padding: "10px 20px",
  //           backgroundColor: "#007bff",
  //           color: "white",
  //           textDecoration: "none",
  //           borderRadius: "4px",
  //         }}
  //       >
  //         Download Resume
  //       </a>
  //       <button
  //         onClick={() => {
  //           setIframeFailed(false);
  //           setIframeLoading(true);
  //           setRetryCount(0);
  //         }}
  //         style={{
  //           padding: "10px 20px",
  //           backgroundColor: "#28a745",
  //           color: "white",
  //           border: "none",
  //           borderRadius: "4px",
  //           cursor: "pointer",
  //         }}
  //       >
  //         Retry
  //       </button>
  //     </div>
  //   </div>
  // );

  // Word Documents - Using Microsoft Office Viewer
  // if (["doc", "docx"].includes(fileExtension)) {
  //   const viewerUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(AwsUrl)}`;

  //   return (
  //     <div style={{ position: "relative", width: "100%", height: "80vh" }}>
  //       {iframeLoading && !iframeFailed && (
  //         <div
  //           style={{
  //             position: "absolute",
  //             top: 0,
  //             left: 0,
  //             right: 0,
  //             bottom: 0,
  //             display: "flex",
  //             flexDirection: "column",
  //             justifyContent: "center",
  //             alignItems: "center",
  //             backgroundColor: "#f5f5f5",
  //             zIndex: 10,
  //           }}
  //         >
  //           <LogoLoader />
  //           <p style={{ marginTop: "20px", color: "#666", fontSize: "16px" }}>
  //             Loading Word document...
  //           </p>
  //           {showSlowWarning && (
  //             <div style={{ textAlign: "center", marginTop: "15px" }}>
  //               <p style={{ color: "#ff9800", fontSize: "14px", marginBottom: "10px" }}>
  //                 Document is taking longer than usual to load.
  //               </p>
  //               <a
  //                 href={AwsUrl}
  //                 download
  //                 style={{
  //                   color: "#007bff",
  //                   textDecoration: "underline",
  //                   fontSize: "14px",
  //                 }}
  //               >
  //                 Click here to download instead
  //               </a>
  //             </div>
  //           )}
  //         </div>
  //       )}

  //       {iframeFailed ? (
  //         renderFallback()
  //       ) : (
  //         <iframe
  //           ref={iframeRef}
  //           key={`${AwsUrl}-${retryCount}`}
  //           src={viewerUrl}
  //           title="Resume Viewer"
  //           style={{
  //             width: "100%",
  //             height: "100%",
  //             border: "none",
  //             display: iframeLoading ? "none" : "block",
  //           }}
  //           onError={handleIframeError}
  //           onLoad={handleIframeLoad}
  //         />
  //       )}
  //     </div>
  //   );
  // }
  console.log(mode)
  if (mode === "IFRAME" && ["doc", "docx"].includes(fileExtension)) {
    // const viewerUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(AwsUrl)}`;
    const viewerUrl = `https://docs.google.com/gview?url=${encodeURIComponent(
      AwsUrl
    )}&embedded=true`;
    return (
      <div style={{ width: "100%", height: "80vh" }}>
        <iframe
          src={viewerUrl}
          title="Resume Viewer"
          style={{ width: "100%", height: "100%", border: "none" }}
          onLoad={() => {
            // ✅ Viewer loaded → cancel fallback
            loadedRef.current = true;
            clearTimeout(timeoutRef.current);
            setIframeLoading(false);
          }}
          onError={() => {
            // ❌ Viewer failed → fallback
            clearTimeout(timeoutRef.current);
            setMode("HTML");
            setIframeLoading(false);
          }}
        />
      </div>
    );
  }
 if (mode === "HTML" && htmlFormat) {
    return (
      <div
        style={{ height: "80vh", overflow: "auto",background: "#f8fafc" }}
        dangerouslySetInnerHTML={{ __html: formatResume(htmlFormat) }}
      />
    );
  }

  // PDF Files
  if (fileExtension === "pdf") {
    return (
      <div style={{ position: "relative", width: "100%", height: "80vh" }}>
        {iframeLoading && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 10,
              textAlign: "center",
            }}
          >
            <LogoLoader />
            <p style={{ marginTop: "20px", color: "#666" }}>Loading PDF...</p>
          </div>
        )}
        <iframe
          src={AwsUrl}
          title="Resume PDF"
          style={{
            width: "100%",
            height: "100%",
            border: "none",
            display: iframeLoading ? "none" : "block",
          }}
          onLoad={handleIframeLoad}
        />
      </div>
    );
  }

  // TXT Files
  if (fileExtension === "txt") {
    return (
      <div
        style={{
          whiteSpace: "pre-wrap",
          padding: "20px",
          border: "1px solid #ccc",
          maxHeight: "80vh",
          overflow: "auto",
          fontFamily: "monospace",
        }}
      >
        {iframeLoading ? (
          <div style={{ textAlign: "center", padding: "40px" }}>
            <LogoLoader />
            <p>Loading text file...</p>
          </div>
        ) : (
          <>
            <h6 style={{ marginBottom: "15px" }}>Resume TXT Content:</h6>
            <pre style={{ margin: 0 }}>{txtContent || "No content available"}</pre>
          </>
        )}
      </div>
    );
  }

  // RTF Files
  if (fileExtension === "rtf") {
    // const microsoftViewerUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(AwsUrl)}`;

    return (
      <div style={{ position: "relative", width: "100%", height: "80vh" }}>
        {/* {iframeLoading && !iframeFailed && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#f5f5f5",
              zIndex: 10,
            }}
          >
            <LogoLoader />
            <p style={{ marginTop: "20px", color: "#666" }}>Loading RTF document...</p>
          </div>
        )}

        {iframeFailed ? (
          // renderFallback()
          <div
        style={{ height: "80vh", overflow: "auto",background: "#fff" }}
        dangerouslySetInnerHTML={{ __html: htmlFormat }}
      />
          // <></>
        ) : (
          // <iframe
          //   ref={iframeRef}
          //   key={`${AwsUrl}-${retryCount}`}
          //   src={microsoftViewerUrl}
          //   title="Resume RTF"
          //   style={{
          //     width: "100%",
          //     height: "100%",
          //     border: "none",
          //     display: iframeLoading ? "none" : "block",
          //   }}
          //   onError={handleIframeError}
          //   onLoad={handleIframeLoad}
          // />
            <div
        style={{ height: "80vh", overflow: "auto",background: "#fff" }}
        dangerouslySetInnerHTML={{ __html: htmlFormat }}
      />
        )} */}
          <div
        style={{ height: "80vh", overflow: "auto",background: "#fff" }}
        dangerouslySetInnerHTML={{ __html: formatResume(htmlFormat) }}
      />
      </div>
    );
  }

  // HTML Files
  if (fileExtension === "html" || fileExtension === "htm") {
    return (
      <div style={{ position: "relative", width: "100%", height: "80vh" }}>
        {iframeLoading && !iframeFailed && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 10,
            }}
          >
            <LogoLoader />
            <p style={{ marginTop: "20px", color: "#666" }}>Loading HTML...</p>
          </div>
        )}

        {iframeFailed ? (
          // renderFallback()
          <></>
        ) : (
          <iframe
            src={AwsUrl}
            title="Resume HTML"
            style={{
              width: "100%",
              height: "100%",
              border: "none",
              display: iframeLoading ? "none" : "block",
            }}
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            onError={handleIframeError}
            onLoad={handleIframeLoad}
          />
        )}
      </div>
    );
  }

  // return renderFallback();
  return <></>;
};

export default DocumentViewerATS;